// extracted by mini-css-extract-plugin
module.exports = {"correct":"L15_correct__3mgHT","bad":"L15_bad__26Ve_"};